import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import ReactList from 'react-list';
import TextSpinner from 'components/TextSpinner';
import autobind from 'autobind-decorator';
import Convert from 'ansi-to-html';

export default class Log extends Component {
  static propTypes = {
    log: PropTypes.string,
    pending: PropTypes.bool,
    children: PropTypes.node,
  }

  constructor(...args) {
    super(...args);
    this.converter = new Convert();
  }

  componentDidUpdate(prevProps) {
    if (this.props.log !== prevProps.log) {
      setTimeout(() => {
        this.handleScrollToBottom();
      }, 0);
    }
  }

  @autobind
  handleScrollToBottom() {
    const { log } = this.props;

    if (this.list) {
      this.list.scrollTo(log.split('\n').length - 1);
    }
  }

  @autobind
  handleScrollToTop() {
    if (this.list) {
      this.list.scrollTo(0);
    }
  }

  renderLine(lines, index, key) {
    const html = this.converter.toHtml(lines[index]);

    return (
      <div key={key} dangerouslySetInnerHTML={{ __html: html }} />
    );
  }

  render() {
    const { log, pending } = this.props;
    const lines = log ? log.split('\n') : [];

    return (
      <div className="Deploy">
        <div className="Deploy__bar">
          <div className="Deploy__bar__left">
            {this.props.children}
          </div>
          <div className="Deploy__bar__right">
            <button onClick={this.handleScrollToTop} className="button button--tiny">
              Scroll to top
            </button>
          </div>
        </div>
        <pre className="Deploy__log">
          {
            lines.length > 0 &&
              <ReactList
                initialIndex={lines.length - 1}
                ref={(el) => { this.list = el; }}
                itemRenderer={this.renderLine.bind(this, lines)}
                length={lines.length}
                type="uniform"
              />
          }
          {
            pending &&
              <div>
                <TextSpinner />
              </div>
          }
        </pre>
        <div className="Deploy__bar">
          <div className="Deploy__bar__left">
            {this.props.children}
          </div>
          <div className="Deploy__bar__right">
            <button onClick={this.handleScrollToBottom} className="button button--tiny">
              Scroll to bottom
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Log.jsx